import globalColumns from "./data";

import { numberWithSpaces } from "root/js/utils";

//
const getRenderMethod = postfix => v =>
  isNaN(v) ? v : numberWithSpaces(Math.round(v)) + (postfix || "");

const getCorrectTitle = (title, postfix) => (postfix ? `${title}, ${postfix.trim()}` : title);
// -------------------------------------------------------------
const getColumnByDataIndex = (dataIndex, postfix) => {
  const defaultProps = globalColumns[dataIndex] || {};
  return { render: getRenderMethod(postfix || defaultProps.postfix), ...defaultProps, dataIndex };
};

const getColumnsByArr = arr => {
  return arr.map(item => {
    // можно передать как объект так и просто название свойства
    const isObj = typeof item === "object";
    const correctDataIndex = isObj ? item.dataIndex : item;
    const defaultProps = getColumnByDataIndex(correctDataIndex, isObj ? item.postfix : null);
    const postfix = item.postfix ? item.postfix : defaultProps.postfix;
    const sortable = defaultProps.sortable === false ? false : true; // чтобы не писать
    // везде true, а указывать false в единичных случаях когда это нужно
    return {
      render: getRenderMethod(postfix),
      ...defaultProps,
      sortable,
      title: getCorrectTitle(defaultProps.title, postfix),
      ...(isObj ? item : {}),
    };
  });
};

//
const defaultCellRender = (v, postfix) => {
  if (!isNaN(v)) return `${numberWithSpaces(Math.round(v))} ${postfix || ""}`;
  return v;
};

export { getColumnByDataIndex, getColumnsByArr, defaultCellRender };
